export default __webpack_public_path__ + "static/media/over-the-counter.47140d8f.png";